import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'cap-too-many-requests',
  templateUrl: './too-many-requests.component.html'
})
export class TooManyRequestsComponent implements OnInit {

  constructor() {
  }

  ngOnInit() {
  }

}
